import { ThunkDispatch } from "@reduxjs/toolkit";

import { ReduxState, ThunkExtraArgument } from "@dashboard/types";

import type { ErrorReducerAction } from "../reducers/errorReducer";
import { SupplierReducerAction } from "../reducers/supplierReducer";
import { addError } from "./addErrorAction";

export type SupplierThunkDispatch = ThunkDispatch<
  ReduxState,
  ThunkExtraArgument,
  SupplierReducerAction | ErrorReducerAction
>;

export const fetchSuppliers = () => {
  return async (
    dispatch: SupplierThunkDispatch,
    getState: () => ReduxState,
    { supplierApi }: ThunkExtraArgument
  ) => {
    return supplierApi
      .fetchSuppliers()
      .then((suppliers) => {
        dispatch({
          type: "FETCHED_SUPPLIERS",
          payload: suppliers,
        } as SupplierReducerAction);
      })
      .catch(addError(dispatch));
  };
};
